import { render, staticRenderFns } from "./dialogRelance.vue?vue&type=template&id=fe9741c4&scoped=true"
import script from "./dialogRelance.vue?vue&type=script&lang=js"
export * from "./dialogRelance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9741c4",
  null
  
)

export default component.exports